
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-intl/-embroider-implicit-modules.js";
